import React, { Component } from "react";
import moment from "moment";

import { DOCUMENT_TYPE_PHOTO } from "constants/dbValues";
import { selectProps, dateFormat, imagePath } from "utils";

import { Input, Select, Radio, Spin, Icon, Pagination, Row, Col } from "antd";
import * as GridGallery from "react-grid-gallery";
import { LazyLoadImage } from "react-lazy-load-image-component";

import { documentService, projectService, tailgateService } from "services";

const typesMap = {
  projects: {
    service: projectService,
    model: "Project",
    list: (_) =>
      (_.state.projects || []).map((p) => ({ id: p.id, label: p.code + " : " + p.label })),
  },
  tailgates: {
    service: tailgateService,
    model: "Tailgate",
    list: (_) => (_.state.tailgates || []).map((t) => ({ id: t.id, label: t.code })),
  },
};

// Composant de la gallerie photo.
// Impémente 2 types : par projet ou par tailgate.
class Gallery extends Component {
  constructor(props) {
    super(props);
    this._isMounted = true;

    var options = JSON.parse(localStorage.getItem(`options[gallery]`)) || {};
    const { type, id } = this.props;

    this.state = {
      per_page: 10,
      page_number: 1,
      totalItems: 0,
      images: [],
      loading: true,
      type: type ? type : options.type || "projects",
      id: id ? id : options.id || null,

      projects: [],
      tailgates: [],
    };

    this.fetchImages = this.fetchImages.bind(this);
    this.fetchList = this.fetchList.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    this.fetchImages();
    this.fetchList(this.state.type);
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  fetchImages() {
    const { type, id, page_number, per_page } = this.state;

    documentService
      .gallery({ type, id }, page_number, per_page, "id", "desc")
      .then((result) => {
        if (!this._isMounted) return;
        const totalItems = result.total;

        result = result.data.map((r) => ({
          src: imagePath(r.url, false),
          thumbnail: imagePath(r.url, true),
          caption: r.label.replace("(", "").replace(")", ""),
          thumbnailWidth: 0,
          thumbnailHeight: 0,
        }));

        const images = result.reduce((reduced, img) => {
          reduced[img.caption] = reduced[img.caption] || [];
          reduced[img.caption].push(img);
          return reduced;
        }, Object.create(null));

        const dates = Object.keys(images).sort(
          (a, b) => moment(b, dateFormat) - moment(a, dateFormat),
        );

        this.setState({ images, dates, totalItems, loading: false });
      })
      .catch((e) => {
        if (!this._isMounted) return;
        this.setState(() => {
          throw new Error(e);
        });
      });
  }

  async fetchList(type) {
    if (type in this.state && this.state[type].length > 0) return;
    const list = await typesMap[type].service.list();
    this.setState({ [type]: list });
  }

  handleChange(value, key) {
    const cacheOptions = (type, id) =>
      localStorage.setItem(`options[gallery]`, JSON.stringify({ type, id }));

    if (key === "type")
      this.setState({ type: value, id: null, loading: true }, () => {
        this.fetchList(value);
        this.fetchImages();
        cacheOptions(this.state.type, this.state.id);
      });
    else
      this.setState({ [key]: value, loading: true }, () => {
        this.fetchImages();
        cacheOptions(this.state.type, this.state.id);
      });
  }

  render() {
    const { images, dates = [], loading, type, id, page_number, per_page, totalItems } = this.state;

    const list = typesMap[type].list(this) || [];

    const renderImages = () => {
      try {
        if (dates.length === 0) throw "No images";

        return dates.map((date, i) => {
          return (
            <div className="date-wrap" key={date}>
              <h2>{date}</h2>
              <GridGallery
                thumbnailImageComponent={(imgProps) => (
                  <LazyLoadImage
                    placeholder={<span className="thumb-placeholder" />}
                    effect="blur"
                    {...imgProps.imageProps}
                  />
                )}
                images={images[date]}
                enableImageSelection={false}
                rowHeight={180}
              />
            </div>
          );
        });
      } catch {
        return <p className="error-images">Aucune image n'est liée aux filtres sélectionnés...</p>;
      }
    };

    const Paginator = () => (
      <Pagination
        defaultPageSize={10}
        showSizeChanger
        onShowSizeChange={(page_number, per_page) => {
          this.setState({ page_number, per_page }, this.fetchImages);
        }}
        onChange={(page_number) => this.setState({ page_number }, this.fetchImages)}
        pageSize={per_page}
        current={page_number}
        total={totalItems}
        hideOnSinglePage
      />
    );

    return (
      <div className="gallery-wrap">
        <div className="gallery-filters">
          <div className="ctn">
            <Radio.Group onChange={(e) => this.handleChange(e.target.value, "type")} value={type}>
              <Radio value="projects">Projets</Radio>
              <Radio value="tailgates">Tailgates</Radio>
            </Radio.Group>
          </div>

          {list.length > 0 && (
            <>
              <div className="ctn">
                <Select
                  {...selectProps()}
                  onChange={(value) => this.handleChange(value, "id")}
                  value={id ? parseInt(id) : null}
                >
                  {list.map((item) => (
                    <Select.Option key={item.id} value={item.id}>
                      {item.label}
                    </Select.Option>
                  ))}
                </Select>
              </div>
            </>
          )}
        </div>
        <div className="pagination-container">
          <Paginator />
        </div>
        <Spin
          indicator={<Icon type="loading" spin style={{ color: "white", fontSize: "52px" }} />}
          spinning={loading}
        >
          {renderImages()}
        </Spin>
        <div className="pagination-container" style={{ marginTop: 48, paddingBottom: 48 }}>
          <Paginator />
        </div>
      </div>
    );
  }
}

export default Gallery;
